import { createAction, props } from "@ngrx/store";
import { IPersonalEdpOrderResponse } from "../../../interfaces/connector-edp/IPersonalEdpOrderResponse";

export const loadPersonalEdpOrder = createAction(
    '[Connector-EDP] Load Personal Edp Order',
    props<{ page: number, size: number }>()
);

export const loadPersonalEdpOrderSuccess = createAction(
    '[Connector-EDP] Load Personal Edp Order success',
    props<{ paginatedOrder: IPersonalEdpOrderResponse }>()
);

export const loadPersonalEdpOrderFailure = createAction(
    '[Connector-EDP] Load Personal Edp Order error',
    props<{ error: any }>()
);
